import React from 'react';

const Services = () => {
  const services = [
    {
      icon: '📈',
      title: 'Consulting Services',
      description: 'Expert guidance for technology strategy and implementation'
    },
    {
      icon: '🔄',
      title: 'Scrum Coaching',
      description: 'Agile transformation and team coaching for better delivery'
    },
    {
      icon: '☁️',
      title: 'Cloud Solutions',
      description: 'Cloud architecture and migration services'
    },
    {
      icon: '🤖',
      title: 'AI Implementation',
      description: 'AI strategy and machine learning solutions'
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-6xl mx-auto px-4">
        <h2 className="text-3xl font-bold text-center mb-12">Our Services</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {services.map((service, index) => (
            <div key={index} className="bg-white p-8 rounded-lg shadow-md text-center">
              <div className="text-4xl mb-4">{service.icon}</div>
              <h3 className="text-xl font-semibold mb-4">{service.title}</h3>
              <p className="text-gray-600">{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
